"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var CheckList_1 = __importDefault(require("./CheckList"));
function Select(props) {
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var tabs = props.tabs, theme = props.theme;
    var selectkeys = tabs.map(function (d) { return d.key; });
    var _a = (0, react_1.useState)(selectkeys[0]), key = _a[0], setKey = _a[1];
    var lists = tabs.find(function (d) { return d.key === key; });
    function renderItem(value) {
        return (react_1.default.createElement("div", { key: "item-".concat(value), className: (0, classnames_1.default)('select-item', { selected: key === value }), onClick: function () { return setKey(value); } }, value));
    }
    return (react_1.default.createElement("div", { className: "".concat(classPrefix, "-coupon-select select-theme-").concat(theme || 'blue') },
        react_1.default.createElement("div", { className: "select-wrap" }, selectkeys.map(function (l) { return renderItem(l); })),
        (lists === null || lists === void 0 ? void 0 : lists.list) ? react_1.default.createElement(CheckList_1.default, { theme: theme, list: lists.list }) : null));
}
exports.default = Select;
//# sourceMappingURL=Select.js.map